import {
  ConfirmedTeamDataFResults,
  TeamCreate,
  UpdateTeamDTO,
} from "../types/team.types";
import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "./withApiErrorHandling";

export class TeamsAPI {
  private static readonly API_URL = "/teams";

  static async createTeam(team: TeamCreate): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.post(TeamsAPI.API_URL, team, true);
    }, "Error al crear el equipo");
  }

  static async getTeam(competitionId?: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      const endpoint = competitionId
        ? `${TeamsAPI.API_URL}?competition_id=${competitionId}`
        : TeamsAPI.API_URL;
      return await httpClient.get(endpoint, true);
    }, "Error al obtener el equipo");
  }

  static async updateTeam(team: UpdateTeamDTO): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.patch(TeamsAPI.API_URL, team, true);
    }, "Error al actualizar el equipo");
  }

  static async updateTeamFamilyCategory(
    isFamily: boolean
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.patch(
        `${TeamsAPI.API_URL}/categories/family`,
        { is_family: isFamily },
        true
      );
    }, "Error al actualizar la categoría familiar del equipo");
  }

  static async getOneTeamOfCompetition(
    id: number,
    competitionId: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.get(
        `${TeamsAPI.API_URL}/${id}?competition_id=${competitionId}`,
        true
      );
    }, "Error al obtener el equipo de la competencia");
  }

  static async deleteTeam(): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.delete(TeamsAPI.API_URL, true);
    }, "Error al eliminar el equipo");
  }

  static async getTeamsStatus(): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.get(`${TeamsAPI.API_URL}/progress`, true);
    }, "Error al obtener el estado del equipo");
  }

  static async adminUpdateTeam(id: number, team: UpdateTeamDTO) {
    return withApiErrorHandling(async () => {
      return await httpClient.patch(`${this.API_URL}/${id}`, team, true);
    }, "Error al actualizar el equipo");
  }

  static async adminUpdateTeamFamilyCategory(id: number, isFamily: boolean) {
    return withApiErrorHandling(async () => {
      return await httpClient.patch(
        `${this.API_URL}/${id}/categories/family`,
        { is_family: isFamily },
        true
      );
    }, "Error al actualizar la categoría del equipo");
  }

  static async getAcceptedTeams(
    compId: number
  ): Promise<ResponseData<ConfirmedTeamDataFResults>> {
    return withApiErrorHandling(async () => {
      return await httpClient.get(
        `${TeamsAPI.API_URL}/accepted?competition_id=${compId}`,
        true
      );
    }, "Error al obtener los equipos aceptados");
  }

  static async exportTeamsPdf(
    competitionId: number,
    status: string
  ): Promise<ResponseData<Blob>> {
    return withApiErrorHandling(async () => {
      return await httpClient.getBlob(
        `${TeamsAPI.API_URL}/pdf?competition_id=${competitionId}&status=${status}`,
        true
      );
    }, "Error al generar el PDF de equipos");
  }
}
